import { render, staticRenderFns } from "./BannerPlanoFornecedor.vue?vue&type=template&id=4ff708ae&scoped=true"
import script from "./BannerPlanoFornecedor.vue?vue&type=script&lang=js"
export * from "./BannerPlanoFornecedor.vue?vue&type=script&lang=js"
import style0 from "./BannerPlanoFornecedor.vue?vue&type=style&index=0&id=4ff708ae&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff708ae",
  null
  
)

export default component.exports